import {BDCSSharedModule} from '../shared/shared.module';
import {BDProjectsModule, BDSharedModule} from '@brother-apps/brother-dealerapp-shared-lib';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';
import {NgxMaskModule} from 'ngx-mask';
import {ISalesConciergeHttpService} from './services/sales-concierge.service.interface';
import {SalesConciergeHttpService} from './services/sales-concierge.service.implementation';
import {SalesConciergeRequestTypeComponent} from './components/steps/request-type/request-type.component';
import {SalesConciergeProductCountInfoComponent} from './components/steps/product-count-info/product-count-info.component';
import {SalesConciergeCustomerInfoComponent} from './components/steps/customer-info/customer-info.component';
import {SalesConciergeCustomerContactInfoComponent} from './components/steps/customer-contact-info/customer-contact-info.component';
import {SalesConciergeModalDynamicComponent} from './components/sales-concierge-modal-dynamic/sales-concierge-modal-dynamic.component';

@NgModule({
    imports: [CommonModule,
        FormsModule,
        BDCSSharedModule,
        BDSharedModule,
        BDProjectsModule,
        NgxMaskModule.forRoot()
    ],
    declarations: [
        // Pages
        SalesConciergeRequestTypeComponent,
        SalesConciergeProductCountInfoComponent,
        SalesConciergeCustomerInfoComponent,
        SalesConciergeCustomerContactInfoComponent,

        SalesConciergeModalDynamicComponent
    ],
    exports: [
        // Pages
        SalesConciergeRequestTypeComponent,
        SalesConciergeProductCountInfoComponent,
        SalesConciergeCustomerInfoComponent,
        SalesConciergeCustomerContactInfoComponent,

        SalesConciergeModalDynamicComponent
    ],
    providers: [
        {provide: ISalesConciergeHttpService, useClass: SalesConciergeHttpService},
    ]
})
export class BDCSSalesConciergeModule {
}
